export default class GlobalFile {
    constructor({
        id = null,
        semester_id = null,
        teacher_id = null,
        created_at = '',
        updated_at = '',
        file_path = [],
        file_metadata = [],
    }) {
        this.id = id;
        this.semester_id = semester_id;
        this.teacher_id = teacher_id;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.file_path = file_path;
        this.file_metadata = file_metadata;
    }

    // Basic validation for global file data
    static validate(globalFileData) {
        if (!globalFileData.semester_id) {
            throw new Error('Semester ID is required');
        }
        if (!globalFileData.teacher_id) {
            throw new Error('Teacher ID is required');
        }
    }

    // Format date to DD.MM.YYYY
    static formatGobalFileDate(date) {
        if (typeof date !== 'string') {
            if (date instanceof Date && !isNaN(date)) {
                date = date.toISOString();
            } else {
                try {
                    date = new Date(date).toISOString();
                } catch (e) {
                    console.error('Invalid date:', date);
                    return '';
                }
            }
        }
        return date ? date.split('T')[0].split('-').reverse().join('.') : '';
    }

}